module.exports = __webpack_public_path__ + "media/images/illustrations/401-error-unauthorized-0566b4bfff5a0d4650c9dd6ea028a755.svg";